import React, { useState, useEffect, useRef} from "react";
import {Box,Card,CardContent,Typography,Table,TableBody,TableCell,TableContainer,TableSortLabel,TablePagination,TableHead,TableRow,Paper,TextField,InputAdornment,Dialog,DialogTitle,CircularProgress} from "@material-ui/core";
import PeopleIcon from "@material-ui/icons/People";
import SearchIcon from "@material-ui/icons/Search";
import LaptopIcon from "@material-ui/icons/Laptop";
import Grid from "@material-ui/core/Grid";
import CheckCircleRoundedIcon from '@material-ui/icons/CheckCircleRounded';
import config from "../config";
import {GetAllADUsers, getAllMaterialNames, getAllValidationCount, getAllCompareCount, fetchAllMaterialNames} from "./RestService";
import { useMsal } from "@azure/msal-react";
import {GlobalUseStyles} from "./GlobalUseStyles.js";
import { useHistory } from "react-router-dom";

export default function AdminTools(props) {

    const {instance} = useMsal();
    const handleCheckAdminRole = props.checkAdminRole;
    const history = useHistory();
    const [userData, setUserData] = useState([]);
    const [materials, setMaterials] = useState([]);
    const [validations, setValidations] = useState([]);
    const [compareMS, setCompareMS] = useState([]);
    const [compareCS, setCompareCS] = useState([]);
    const [comparePCC, setComparePCC] = useState([]);
    const [userCount, setUserCount] = useState([]);
    const [materialCount, setMaterialCount] = useState([]);
    const [materialNames, setMaterialnames] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [searchTextMaterial, setSearchTextMaterial] = useState("");
    const [circularProgressOpen, setCircularProgressOpen] = useState(false);
    const globalClasses = GlobalUseStyles();
    const [order, setOrder] = useState("asc");
    const [orderBy, setOrderBy] = useState("name");
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [search, setSearch] = useState("");

    const [orderMat, setOrderMat] = useState("asc");
    const [orderByMat, setOrderByMat] = useState("kmnumber");
    const [pageMat, setPageMat] = useState(0);
    const [rowsPerPageMat, setRowsPerPageMat] = useState(5);
    const [searchMat, setSearchMat] = useState("");

    const handleRequestSort = (property) => {
        const isAsc = orderBy === property && order === "asc";
        setOrder(isAsc ? "desc" : "asc");
        setOrderBy(property);
    };
     
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleSearch = (event) => {
        setSearch(event.target.value);
        setPage(0); // Reset page when search changes
    };
     
    // Sorting function
    const sortData = (array) => {
        return array.sort((a, b) => {
            if (a[orderBy] < b[orderBy]) {
            return order === "asc" ? -1 : 1;
            }
            if (a[orderBy] > b[orderBy]) {
            return order === "asc" ? 1 : -1;
            }
            return 0;
        });
    };

    // Filter data by search
    const filteredData = userData.filter(
        (row) =>
        row.name.toLowerCase().includes(search.toLowerCase()) ||
            row.role.toString().includes(search.toLowerCase()) ||
            row.userid.toString().includes(search.toLowerCase()) ||
            row.department.toString().includes(search.toLowerCase()) ||
            row.country.toString().includes(search.toLowerCase())
        );
        
        // Paginate data
        const paginatedData = sortData(filteredData).slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
    );
    
    const fetchAllADUsers = async () => {
        const userData = await GetAllADUsers(instance);
        setUserData(userData);
        setUserCount(userData.length);
    }

    const fetchBatchData = async () => {
        const materials = await getAllMaterialNames(instance);
        setMaterials(materials);
    }

    const fetchValidatinData = async () => {
        const validations = await getAllValidationCount(instance);
        setValidations(validations);
    }

    const fetchCompareDataMS = async () => {
        const compareMS = await getAllCompareCount(instance,"Master Structure");
        setCompareMS(compareMS);
    }

    const fetchCompareDataCS = async () => {
        const compareCS = await getAllCompareCount(instance,"Configuration Structure");
        setCompareCS(compareCS);
    }

    const fetchCompareDataPCC = async () => {
        const comparePCC = await getAllCompareCount(instance,"PDM CAD Comparison");
        setComparePCC(comparePCC);
    }

    const fetchAllMaterialName = async () => {
        const materialnames = await fetchAllMaterialNames(instance);
        setMaterialnames(materialnames);
        setMaterialCount(materialnames.length);
    }

    useEffect(() => {
        sessionStorage.setItem("materialCount", "");
        if (!handleCheckAdminRole) {
            history.push("/#/batches");
        }
        setCircularProgressOpen(true);
        
        fetchAllMaterialName();
        fetchAllADUsers();
        fetchBatchData();
        fetchValidatinData();
        fetchCompareDataMS();
        fetchCompareDataCS();
        fetchCompareDataPCC();
    }, []);

    const filterMaterialNames = async () => {
        setMaterialnames(materialNames);
    }

    useEffect(() => {
        filterMaterialNames();
    }, [searchTextMaterial]);

      const filterUserNames = async () => {
        setUserData(userData);
      }

      useEffect(() => {
        filterUserNames();
      }, [searchText]);
    
      useEffect(() => {
        const timer = setTimeout(() => {
            setCircularProgressOpen(false);
            if(document.getElementById("CirProg"))
            {
                document.getElementById("CirProg").style.display="none";
            }
        }, 30000);
        return () => clearTimeout(timer);
    }, []);

    let materialData = [];

    if(materialNames?.length > 0) {
        materialNames.forEach((row, index) => {
            let kmnumber,testorder,datavalidation,mstructure,cstructure,pdmcad = "0";
            kmnumber = row["kmnumber"];
            materials?.map((r, ind) => (
                (row["kmnumber"]===r["kmnumber"])? testorder = r["count"]:"0"
            ))
            validations?.map((r, ind) => (
                (row["kmnumber"]===r["kmnumber"])? datavalidation = r["count"]:"0"
            ))
            compareMS?.map((r, ind) => (
                (row["kmnumber"]===r["kmnumber"])? mstructure = r["count"]:"0"
            ))
            compareCS?.map((r, ind) => (
                (row["kmnumber"]===r["kmnumber"])? cstructure = r["count"]:"0"
            ))
            comparePCC?.map((r, ind) => (
                (row["kmnumber"]===r["kmnumber"])? pdmcad = r["count"]:"0"
            ))
            const pushList = {"kmnumber":kmnumber, 
            "testorder":testorder ?? "0", "datavalidation":datavalidation ?? "0",
            "mstructure":mstructure ?? "0", "cstructure":cstructure ?? "0", "pdmcad":pdmcad ?? "0"}
            materialData.push(pushList);
        }
        );
    }

    let validationData = [];

    if(validations?.length > 0) {
        validations.forEach((row, index) => {
            let vkmnum=row["kmnumber"];

            let kmnumber,testorder,datavalidation,mstructure,cstructure,pdmcad = "0";

            materialNames.forEach((rows, ind) => {
                let mkmnum=rows["kmnumber"];
                if(vkmnum!==mkmnum && !validationData.includes(vkmnum))
                {
                    kmnumber=vkmnum;
                    validationData.push(vkmnum);
                    datavalidation = row["count"];
                    
                    const pushList = {"kmnumber":kmnumber, 
                    "testorder":testorder ?? "0", "datavalidation":datavalidation ?? "0",
                    "mstructure":mstructure ?? "0", "cstructure":cstructure ?? "0", "pdmcad":pdmcad ?? "0"}
                    materialData.push(pushList);
                }
            });
        }
        );
    }

    let filterMaterial = [];
    let finalMaterialData = [];

    if(materialData?.length > 0) {
        materialData.forEach((row, index) => {
            let kmnumber = row["kmnumber"];
            let testorder = row["testorder"];
            let datavalidation = row["datavalidation"];
            let mstructure = row["mstructure"];
            let cstructure = row["cstructure"];
            let pdmcad = row["pdmcad"];
            if(!filterMaterial.includes(kmnumber))
            {
                filterMaterial.push(kmnumber);

                const pushList = {"kmnumber":kmnumber, 
                    "testorder":testorder ?? "0", "datavalidation":datavalidation ?? "0",
                    "mstructure":mstructure ?? "0", "cstructure":cstructure ?? "0", "pdmcad":pdmcad ?? "0"}
                    finalMaterialData.push(pushList);
            }
        }
        );
        sessionStorage.setItem("materialCount", finalMaterialData.length.toString());
    }
    
    const handleRequestSortMat = (property) => {
        const isAsc = orderByMat === property && orderMat === "asc";
        setOrderMat(isAsc ? "desc" : "asc");
        setOrderByMat(property);
    };
     
    const handleChangePageMat = (event, newPage) => {
        setPageMat(newPage);
    };
     
    const handleChangeRowsPerPageMat = (event) => {
        setRowsPerPageMat(parseInt(event.target.value, 10));
        setPageMat(0);
    };
     
    const handleSearchMat = (event) => {
        setSearchMat(event.target.value);
        setPageMat(0); // Reset page when search changes
    };
     
    // Sorting function
    const sortDataMat = (array) => {
        return array.sort((a, b) => {
            if(orderByMat==="kmnumber")
            {
                if (a[orderByMat] < b[orderByMat]) {
                    return orderMat === "asc" ? -1 : 1;
                }
                if (a[orderByMat] > b[orderByMat]) {
                    return orderMat === "asc" ? 1 : -1;
                }
                return 0;
            }
            else
            {
                if (parseInt(a[orderByMat]) < parseInt(b[orderByMat])) {
                    return orderMat === "asc" ? -1 : 1;
                }
                if (parseInt(a[orderByMat]) > parseInt(b[orderByMat])) {
                return orderMat === "asc" ? 1 : -1;
                }
                return 0;
            }
        }
        );
    };
     
    // Filter data by search
    const filteredDataMat = finalMaterialData.filter(
    (row) =>
        row.kmnumber.toLowerCase().includes(searchMat.toLowerCase())
    );
    
    // Paginate data
    const paginatedDataMat = sortDataMat(filteredDataMat).slice(
    pageMat * rowsPerPageMat,
    pageMat * rowsPerPageMat + rowsPerPageMat
    );
    
    return (
        
        <Box p={2} style={{ marginleft:10 , paddingTop:20, paddingBottom:15 }}>
            <div className={globalClasses.textBar}>
                <Typography variant="h5" color="textPrimary" align="left">
                    {'Admin Tools'}
                </Typography>
            </div>
            <div style={{ textAlign: "left" }}>
                <Grid container spacing={2}>
                    <Grid item xs={4}>
                        <Card>
                            <CardContent>
                                <Typography
                                    variant="h6"
                                    color="text.secondary"
                                >
                                    Total no. of users
                                </Typography>
                                <Typography variant="h3" color="primary">
                                    {userCount}
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={4}>
                        <Card>
                            <CardContent>
                                <Typography
                                    variant="h6"
                                    color="text.secondary"
                                >
                                    Total no. of materials
                                </Typography>
                                <Typography variant="h3" color="primary">
                                    {sessionStorage.getItem("materialCount")}
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </div>

            <div style={{marginTop:'3%'}}>
            <Paper>
            <Grid container spacing={2}>
                <Grid item xs={4}>
                    <div style={{padding:'10%'}}>
                        <Typography variant="h5" color="textPrimary" align="left">
                            {'All Users List'}
                        </Typography>
                    </div>
                </Grid>
                <Grid item xs={4}>
                </Grid>
                <Grid item xs={4}>
                    <TextField
                        label="Search"
                        variant="outlined"
                        fullWidth
                        onChange={handleSearch}
                        value={search}
                        style={{ padding: "10px", marginTop: "10px" }}
                    />
                </Grid>
            </Grid>
            <TableContainer style={{ maxHeight : 350 }}>
                <Table stickyHeader>
                <TableHead style={{background: 'aliceblue !important'}}>
                    <TableRow>
                    <TableCell sortDirection={orderBy === "role" ? order : false}>
                        <TableSortLabel
                        active={orderBy === "role"}
                        direction={orderBy === "role" ? order : "asc"}
                        onClick={() => handleRequestSort("role")}
                        >
                        Role
                        </TableSortLabel>
                    </TableCell>
                    <TableCell sortDirection={orderBy === "name" ? order : false}>
                        <TableSortLabel
                        active={orderBy === "name"}
                        direction={orderBy === "name" ? order : "asc"}
                        onClick={() => handleRequestSort("name")}
                        >
                        Name
                        </TableSortLabel>
                    </TableCell>

                    <TableCell sortDirection={orderBy === "userid" ? order : false}>
                        <TableSortLabel
                        active={orderBy === "userid"}
                        direction={orderBy === "userid" ? order : "asc"}
                        onClick={() => handleRequestSort("userid")}
                        >
                        KONE ID
                        </TableSortLabel>
                    </TableCell>
                    <TableCell sortDirection={orderBy === "department" ? order : false}>
                        <TableSortLabel
                        active={orderBy === "department"}
                        direction={orderBy === "department" ? order : "asc"}
                        onClick={() => handleRequestSort("department")}
                        >
                        Department
                        </TableSortLabel>
                    </TableCell>

                    <TableCell sortDirection={orderBy === "country" ? order : false}>
                        <TableSortLabel
                        active={orderBy === "country"}
                        direction={orderBy === "country" ? order : "asc"}
                        onClick={() => handleRequestSort("country")}
						style={{background: 'aliceblue !important'}}
                        >
                        Country
                        </TableSortLabel>
                    </TableCell>
                    
                    </TableRow>
                </TableHead>
                <TableBody>
                    
                    {paginatedData?.length > 0 ? ( paginatedData.map((row, index) => (
                        <TableRow key={index}>
                            <TableCell>
                                {row.role}
                            </TableCell>
                            <TableCell>
                                {row.name}
                            </TableCell>
                            <TableCell>
                                {row.userid}
                            </TableCell>
                            <TableCell>
                                {row.department}
                            </TableCell>
                            <TableCell>
                                {row.country}
                            </TableCell>
                        </TableRow>
                    ))) : (
                        <TableRow>
                            <TableCell colSpan={5} align="center">
                                No users found.
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[5, 10, 25, 50, 100]}
                component="div"
                count={filteredData.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
            </Paper>
            </div>

            <div style={{marginTop: "3%"}}>
            <Paper>
                <Grid container spacing={2}>
                    <Grid item xs={4}>
                        <div style={{padding:'10%'}}>
                            <Typography variant="h5" color="textPrimary" align="left">
                                {'All Tested Materials List'}
                            </Typography>
                        </div>
                    </Grid>
                    <Grid item xs={4}>
                    </Grid>
                    <Grid item xs={4}>
                        <TextField
                            label="Search"
                            variant="outlined"
                            fullWidth
                            onChange={handleSearchMat}
                            value={searchMat}
                            style={{ padding: "10px", marginTop: "10px" }}
                        />
                    </Grid>
                </Grid>
                <TableContainer style={{ maxHeight : 350 }}>
                    <Table stickyHeader>
                    <TableHead style={{background: 'aliceblue !important'}}>
                        <TableRow>
                        <TableCell sortDirection={orderByMat === "kmnumber" ? orderMat : false}>
                            <TableSortLabel
                            active={orderByMat === "kmnumber"}
                            direction={orderByMat === "kmnumber" ? orderMat : "asc"}
                            onClick={() => handleRequestSortMat("kmnumber")}
                            >
                            Material
                            </TableSortLabel>
                        </TableCell>
                        
                        <TableCell sortDirection={orderByMat === "testorder" ? orderMat : false}>
                            <TableSortLabel
                            active={orderByMat === "testorder"}
                            direction={orderByMat === "testorder" ? orderMat : "asc"}
                            onClick={() => handleRequestSortMat("testorder")}
                            >
                            Executed test orders
                            </TableSortLabel>
                        </TableCell>
                        
                        <TableCell sortDirection={orderByMat === "datavalidation" ? orderMat : false}>
                            <TableSortLabel
                            active={orderByMat === "datavalidation"}
                            direction={orderByMat === "datavalidation" ? orderMat : "asc"}
                            onClick={() => handleRequestSortMat("datavalidation")}
                            >
                            Executed Data validations
                            </TableSortLabel>
                        </TableCell>
                        
                        <TableCell sortDirection={orderByMat === "mstructure" ? orderMat : false}>
                            <TableSortLabel
                            active={orderByMat === "mstructure"}
                            direction={orderByMat === "mstructure" ? orderMat : "asc"}
                            onClick={() => handleRequestSortMat("mstructure")}
                            >
                            Executed Master structure comparisons
                            </TableSortLabel>
                        </TableCell>
                        
                        <TableCell sortDirection={orderByMat === "cstructure" ? orderMat : false}>
                            <TableSortLabel
                            active={orderByMat === "cstructure"}
                            direction={orderByMat === "cstructure" ? orderMat : "asc"}
                            onClick={() => handleRequestSortMat("cstructure")}
                            >
                            Executed Configurated structure comparisons
                            </TableSortLabel>
                        </TableCell>
                        
                        <TableCell sortDirection={orderByMat === "pdmcad" ? orderMat : false}>
                            <TableSortLabel
                            active={orderByMat === "pdmcad"}
                            direction={orderByMat === "pdmcad" ? orderMat : "asc"}
                            onClick={() => handleRequestSortMat("pdmcad")}
                            >
                            Executed PDM CAD comparisons
                            </TableSortLabel>
                        </TableCell>
                        
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        
                        {paginatedDataMat?.length > 0 ? ( paginatedDataMat.map((row, index) => (
                            <TableRow key={index}>
                                <TableCell>
                                    {row.kmnumber}
                                </TableCell>
                                <TableCell>
                                    {row.testorder}
                                </TableCell>
                                <TableCell>
                                    {row.datavalidation}
                                </TableCell>
                                <TableCell>
                                    {row.mstructure}
                                </TableCell>
                                <TableCell>
                                    {row.cstructure}
                                </TableCell>
                                <TableCell>
                                    {row.pdmcad}
                                </TableCell>
                            </TableRow>
                        ))) : (
                            <TableRow>
                                <TableCell colSpan={6} align="center">
                                    No materials found.
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[5, 10, 25, 50, 100]}
                    component="div"
                    count={filteredDataMat.length}
                    rowsPerPage={rowsPerPageMat}
                    page={pageMat}
                    onPageChange={handleChangePageMat}
                    onRowsPerPageChange={handleChangeRowsPerPageMat}
                />
                </Paper>
            </div>
            <Dialog open = {circularProgressOpen} id="CirProg">
            <DialogTitle align="center">Loading data</DialogTitle>
            <table width="200">
                <tr>
                    <td width="200" align="center">
                        <CircularProgress />
                    </td>
                </tr>
            </table>
            <DialogTitle></DialogTitle>
            </Dialog>
        </Box>
    );
}